// @ts-nocheck
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { getInventoryWithPermission } from '@store/HR/Organizations/organizationSlice';

const useGetInventoryWithPermission = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (data?.length === 0) {
      dispatch(getInventoryWithPermission());
    }
  }, []);

  const {
    InventoryList: data,
    loadingInventory: loading,
    errorInventory: error
  } = useSelector(state => state.Organizations);

  const InventoryOptions =
    data &&
    data?.map(item => ({
      value: item.id,
      label: i18n.language === 'en' ? item.name : item.name2,
      //~
      operatingUnitId: item.operatingUnitId
    }));

  return { data, InventoryOptions, loading, error };
};

export default useGetInventoryWithPermission;
